import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ef9c7f14&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ef9c7f14&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef9c7f14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef9c7f14')) {
      api.createRecord('ef9c7f14', component.options)
    } else {
      api.reload('ef9c7f14', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ef9c7f14&scoped=true", function () {
      api.rerender('ef9c7f14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/senate/temporary-class/index.vue"
export default component.exports